import { MdIosShare, MdOutlineCurrencyExchange } from 'react-icons/md';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { copyToClipboard } from 'legacy/common/utils/clipboard';
import generateTransferUrl from '../../helpers/generateTransferUrl';
import * as toast from 'legacy/common/utils/toast';
import { StepProps, StepsIds } from '../../types';

const DefaultOptions = ({ ticket, onClose, goToStep }: StepProps) => {
  const onTransferClick = () => {
    copyToClipboard(generateTransferUrl(ticket.id));
    toast.success('Link Copied! Make a new memory-- share it with a friend.');
    onClose();
  };

  return (
    <div className="p-4 flex flex-col gap-4">
      <Button
        onClick={onTransferClick}
        type={ButtonType.Inverted}
        icon={<MdIosShare size={18} />}
      >
        Transfer Ticket
      </Button>
      <div className="border-t-1 border-solid border-gray-200 p-4">
        <Button
          onClick={() => goToStep(StepsIds.RequestRefundStep)}
          type={ButtonType.Clear}
          className="text-red-500"
          icon={<MdOutlineCurrencyExchange size={18} />}
        >
          Request refund
        </Button>
      </div>
    </div>
  );
};

export default DefaultOptions;
